import { render, staticRenderFns } from "./ContactUsForm.vue?vue&type=template&id=31bc4b43&"
import script from "./ContactUsForm.vue?vue&type=script&lang=js&"
export * from "./ContactUsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports